import { createContext } from "react";

import type { User } from "@/types/user";

export type SessionStatus = "loading" | "ready";

export interface SessionContextValue {
  status: SessionStatus;
  /** The signed-in user, or null when there is no identity (or still loading). */
  user: User | null;
  /** CSRF token for state-changing requests, or null if unavailable. */
  csrfToken: string | null;
  /** Effective permission keys for the signed-in user (empty when none/loading). */
  permissions: string[];
}

/**
 * Session context: who is signed in, plus the CSRF token. Populated once on
 * mount by app/providers/AuthProvider. Read via the `useCurrentUser` hook.
 */
export const SessionContext = createContext<SessionContextValue | undefined>(undefined);
